import {BASE_PATH, constants} from "../config";
import {getStudent, getUser} from "./UserService";
import userFeatureFlags from "./user_feature_flags";
import {getAuthToken} from "./authtoken";
import Cookie from "js-cookie";
import log from "./Logger";
import {createPretest} from "./api";
import Utils from "./Utils";
async function createPretestTask(studentId) {
  try{
    const res = await createPretest(studentId)
    log.info(`createPretestTask: studentId=${studentId}, res=${JSON.stringify(res)}`)
  }catch (e) {
    if (e.status === 403) {
        log.warn(`createPretestTask: studentId=${studentId}, rejected by server with status 403 student already has pretest`)
    }
    log.error(`createPretestTask: studentId=${studentId}, status=${e.status}, message=${e.message}`)
  }
}

function getUserDetails() {
  const user = getUser()
  return {
    displayName: Utils.getCurrentUserDisplayName() || user?.username,
    avatarIcon: Utils.getUserSetting(user, 'avatarIcon'),
    avatarColor: Utils.getUserSetting(user, 'avatarColor'),
  }
}
function pretest() {
  log.info(`new pretest redirect`)
  const studentId = getStudent().studentId;
  log.info(`new pretest redirect: studentId=${studentId}`)
  void createPretestTask(studentId);
  Cookie.set('currentStudentId', studentId, {expires: 1, domain: '.readtheory.org'});
  Cookie.set('currentUserToken', getAuthToken(), {expires: 1, domain: '.readtheory.org'});
  Cookie.set('user-details', JSON.stringify(getUserDetails()), {expires: 1, domain: '.readtheory.org'});
  return constants.studentAppPath
}

//TODO: replace cookie with API call

function getPretestURL() {
  if (getStudent()?.initialLevel === null) {
    if (userFeatureFlags.isActive('nuxt-pretest')) {
      if(preTestCompleted()){
        return BASE_PATH + '/app/student/quiz'
      }
      return  pretest();
    } else {
      return BASE_PATH + '/app/student/pretest';
    }
  } else {
    return BASE_PATH + '/app/student/quiz';
  }
}

const pretestURL = getPretestURL()

function preTestCompleted() {
  return Cookie.get('pre-test-completed-time') > new Date().getTime() - 1000 * 60;
}

export function getQuizURL(onlyForNewQuiz = false) {
  return pretestURL;
}
